import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {Identity} from '../identity.model';
import {IdentityService} from '../identity.service';
import {Observable, Subject, take, throwError} from 'rxjs';
import {FuncsService, passwordsDontMatchValidator} from 'src/app/shared/funcs.service';
import {ConfigService} from '../../config.service';
import {HttpClient} from '@angular/common/http';
import {OtpDeliveryMethod} from '../../auth/login/login.model';
import {GenericResponse} from '../../api-interfaces';
import {catchError, finalize, tap} from 'rxjs/operators';
import {NotificationService, NotificationType} from '../../shared/notification.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-edit-credentials',
  templateUrl: './edit-credentials.component.html',
  styleUrls: ['./edit-credentials.component.sass']
})
export class EditCredentialsComponent implements OnInit {

  isSpinning: boolean;
  validateForm!: UntypedFormGroup;
  identity: Identity;
  newPassword: string;
  confirmNewPassword: string;

  onModifyPasswrdEventSubject: Subject<void> = new Subject<void>();
  isQrCodeAssociationComponentVisible = false;

  readonly showAuthenticationWithApp = environment.showAuthenticationWithApp;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private identityService: IdentityService,
    private http: HttpClient,
    private notificationService: NotificationService
  ) {
  }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      oldPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required]],
      confirmNewPassword: [null, [Validators.required]],
    }, {validators: passwordsDontMatchValidator});
    this.identity = this.identityService.getCurrentIdentity();
    this.identityService.currentIdentityChanged.subscribe((data: Identity) => {
      this.identity = data;
    });
  }

  onChangePassword(): void {
    this.onModifyPasswrdEventSubject.next();
  }

  getDisplaySpidLevel(): string {
    const level = this.identityService.getCurrentIdentity().level;
    let str = '';
    let i = 0;
    for (i = 0; i < level; i++) {
      str = str + (i + 1).toString();
      if (i < level - 2) {
        str = str + ', ';
      } else if (i === level - 2) {
        str = str + ' e ';
      }
    }

    return str;
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  onChangeAuthenticationWithApp($event: boolean): void {
    this.isQrCodeAssociationComponentVisible = $event;
    if (!$event) {
      this.updateOtpDeliveryMethod$($event).subscribe({
        next: () => this.identity.otp_delivery_methods.APP.enabled = $event,
        error: () => this.identity.otp_delivery_methods.APP.enabled = !$event
      });
    }
  }

  onEndQrCodeAssociation(): void {
    this.isQrCodeAssociationComponentVisible = false;
    this.identity.otp_delivery_methods.APP.enabled = false;
  }

  updateOtpDeliveryMethod($event: boolean): void {
    this.updateOtpDeliveryMethod$($event).subscribe();
  }

  private updateOtpDeliveryMethod$(enabled: boolean): Observable<GenericResponse> {
    const url = `${ConfigService.settings.baseUrl}/otp_delivery_method`;
    const payload = {
      otp_delivery_method: OtpDeliveryMethod.APP,
      enabled,
      show_login_popup: false
    };
    return this.http.post<GenericResponse>(url, payload, {withCredentials: true}).pipe(
      take(1),
      tap(() => {
        this.isQrCodeAssociationComponentVisible = false;
        this.notificationService.createNotification(
          NotificationType.SUCCESS,
          'Operazione eseguita con successo',
          'Il metodo di autenticazione tramite App è stato modificato con successo.'
        );
      }),
      finalize(() => this.isQrCodeAssociationComponentVisible = false),
      catchError(err => {
        this.notificationService.createNotification(
          NotificationType.ERROR,
          'Errore',
          'Non è stato possibile modificare il metodo di invio OTP tramite app'
        );
        return throwError(() => err);
      })
    );
  }

}
